import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon, BatteryWarningIcon, TrendingDownIcon, UsersIcon } from 'lucide-react';
export function Problem() {
  const pains = [{
    icon: <BatteryWarningIcon className="w-8 h-8 text-red-500" data-id="element-85" />,
    title: 'El Domingo Perdido',
    desc: 'Son las 11 de la noche y seguís armando planillas en Excel. El día que era para descansar se volvió tu jornada laboral más pesada y menos agradecida.'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-orange-500" data-id="element-86" />,
    title: 'El Alumno Fantasma',
    desc: 'Entrenó meses con vos, mejoró, pero un día deja de venir. ¿Por qué? Porque no tuviste cómo mostrarle su progreso con datos reales. La percepción le ganó a la realidad.'
  }, {
    icon: <AlertCircleIcon className="w-8 h-8 text-yellow-500" data-id="element-87" />,
    title: 'El Muro del Km 30',
    desc: 'El plan de pasadas estaba perfecto, pero la nutrición y la fuerza fueron improvisadas. Llega la carrera, el alumno choca contra el muro y la culpa recae en vos.'
  }, {
    icon: <TrendingDownIcon className="w-8 h-8 text-brand-volt" data-id="element-88" />,
    title: 'El Techo de Cristal',
    desc: 'Cobrás lo mismo hace años por miedo a que se vayan. No sabés cómo justificar un aumento porque sentís que no te diferenciás del profe que cobra la mitad.'
  }];
  return <section className="py-24 px-4 bg-brand-surface border-y border-brand-muted/10" data-id="element-89">
      <div className="max-w-6xl mx-auto" data-id="element-90">
        <FadeIn data-id="element-91">
          <div className="max-w-3xl mb-16" data-id="element-92">
            <h2 className="text-brand-volt font-bold tracking-widest text-sm mb-4" data-id="element-93">
              LA REALIDAD INCÓMODA
            </h2>
            <h3 className="text-4xl sm:text-5xl font-black text-white leading-tight" data-id="element-94">
              SABÉS ENTRENAR. <br className="hidden sm:block" data-id="element-95" />
              <span className="text-gray-500" data-id="element-96">PERO TE FALTA UN SISTEMA.</span>
            </h3>
            <p className="mt-6 text-xl text-gray-400 leading-relaxed normal-case" data-id="element-97">
              Te formaste para hacer que la gente corra más rápido y sin
              lesiones. No para ser fisiólogo, nutricionista, psicólogo y
              experto en marketing al mismo tiempo. Y esa falta de estructura te
              está costando caro.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-98">
          {pains.map((pain, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-99">
              <div className="bg-brand-dark p-8 border border-brand-muted/20 hover:border-brand-volt/50 transition-colors group h-full" data-id="element-100">
                <div className="mb-6 bg-brand-surface w-16 h-16 flex items-center justify-center rounded-lg border border-brand-muted/10 group-hover:scale-110 transition-transform" data-id="element-101">
                  {pain.icon}
                </div>
                <h4 className="text-2xl font-bold text-white mb-3" data-id="element-102">
                  {pain.title}
                </h4>
                <p className="text-gray-400 leading-relaxed normal-case" data-id="element-103">
                  {pain.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}